var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.333,
    height: 63.707,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2088",
    transform: "translate(-1496.499 -609.424)",
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2087"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3267",
    d: "M1591.598 673.131h-.29a11.2 11.2 0 01-7.819-3.475 11.017 11.017 0 01-3.041-7.963 11.2 11.2 0 013.475-7.819 11.161 11.161 0 0118.823 8.108v.29a11.094 11.094 0 01-11.148 10.859zm0-18.1a6.922 6.922 0 00-6.95 6.66 6.769 6.769 0 001.882 4.923 7.338 7.338 0 004.778 2.172 6.924 6.924 0 007.095-6.66v-.145a6.675 6.675 0 00-6.66-6.805c-.001-.143-.001-.143-.145-.143z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3268",
    d: "M1591.743 667.34a5.789 5.789 0 01-3.764-1.448 5.468 5.468 0 01-1.738-3.909 5.412 5.412 0 015.357-5.647h.145a5.378 5.378 0 015.5 5.357v.145a5.592 5.592 0 01-5.5 5.5zm0-6.66a1.142 1.142 0 00-1.158 1.158 1.251 1.251 0 00.434.869 1.063 1.063 0 00.869.29 1.246 1.246 0 001.158-1.158 1.373 1.373 0 00-1.303-1.159z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3269",
    d: "M1612.158 659.231h-11a1.94 1.94 0 01-1.882-1.158 7.341 7.341 0 00-3.62-3.62l-.145-.145a8.03 8.03 0 00-10.859 3.764 2.259 2.259 0 01-1.882 1.158h-29.827a1.94 1.94 0 01-1.882-1.158 7.967 7.967 0 00-3.62-3.62h-.145a8.236 8.236 0 00-11 3.765 2.259 2.259 0 01-1.882 1.158h-7.674a2.227 2.227 0 01-2.172-2.172v-32.142a6.9 6.9 0 012.027-4.923 6.814 6.814 0 014.778-2.027h48.649a5.393 5.393 0 015.212 4.054l3.62 13.321 20.85 1.3a5.468 5.468 0 015.212 5.647l-.145 14.769a3.153 3.153 0 01-2.613 2.029zm-9.846-4.344h7.529l.145-12.6v-.145a1.373 1.373 0 00-1.158-1.3l-22.3-1.448a2.322 2.322 0 01-2.027-1.593l-4.054-14.769a1.089 1.089 0 00-1.014-.724h-48.649a2.472 2.472 0 00-2.461 2.461v29.971h4.344a12.393 12.393 0 0116.072-4.488l.29.145a12.614 12.614 0 014.778 4.344h27.365a12.393 12.393 0 0116.072-4.488l.29.145a11.894 11.894 0 014.778 4.489zm-34.46-7.963h-6.081a2.172 2.172 0 110-4.344h6.081a2.172 2.172 0 110 4.344z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3270",
    d: "M1535.42 620.284a2.227 2.227 0 01-2.172-2.172v-5.5a2.172 2.172 0 114.344 0v5.5a2.227 2.227 0 01-2.172 2.172z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3271",
    d: "M1572.486 620.284a2.227 2.227 0 01-2.172-2.172v-5.5a2.172 2.172 0 014.344 0v5.5a2.132 2.132 0 01-2.172 2.172z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3272",
    d: "M1579.725 613.768h-51.69a2.172 2.172 0 110-4.344h51.69a2.227 2.227 0 012.172 2.172 2.132 2.132 0 01-2.172 2.172z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3273",
    d: "M1532.813 661.549h-9.99a2.172 2.172 0 110-4.344h9.99a2.227 2.227 0 012.172 2.172 2.132 2.132 0 01-2.172 2.172z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3274",
    d: "M1581.753 661.549h-27.655a2.172 2.172 0 110-4.344h27.655a2.172 2.172 0 110 4.344z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3275",
    d: "M1617.66 661.548h-17.085a2.172 2.172 0 010-4.344h14.913v-10.565a2.172 2.172 0 014.344 0v12.741a2.227 2.227 0 01-2.172 2.168z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3276",
    d: "M1586.82 639.541h-59.219a2.172 2.172 0 110-4.344h59.219a2.172 2.172 0 110 4.344z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3277",
    d: "M1556.849 639.106a2.227 2.227 0 01-2.172-2.172v-16.647a2.172 2.172 0 114.344 0v16.651a2.132 2.132 0 01-2.172 2.168z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3278",
    d: "M1526.153 651.123h-4.633a5.654 5.654 0 01-5.647-5.647v-13.175a5.654 5.654 0 015.647-5.647h4.633a2.227 2.227 0 012.172 2.172v20.126a2.052 2.052 0 01-2.172 2.171zm-4.633-19.981a1.3 1.3 0 00-1.3 1.3v13.176a1.3 1.3 0 001.3 1.3h2.461v-15.775z"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1693",
    width: 22.556,
    height: 7.089,
    rx: 1.708,
    transform: "translate(1496.499 666.043)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1694",
    d: "M1531.277 658.4h2.617v13.283h-2.617z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3279",
    d: "M1535.903 673.132h-6.635l1.581-2.75h3.473z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1695",
    width: 9.684,
    height: 1.407,
    rx: 0.486,
    transform: "rotate(16.19 -1574.228 5686.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 81",
    cx: 3.4,
    cy: 3.4,
    r: 3.4,
    transform: "translate(1540.01 657.638)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3280",
    d: "M1543.413 662.116c-5.8 0-10.339-2.391-10.339-5.441l1.448-.724c0 1.888 3.652 3.993 8.891 3.993s8.893-2.105 8.893-3.993l1.448.724c-.004 3.051-4.541 5.441-10.341 5.441z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenVehicle);
export default __webpack_public_path__ + "static/media/brokenVehicle.bed9d8277becea41b5faf8705f770821.svg";
export { ForwardRef as ReactComponent };